var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Sample',{staticClass:"Sample-mineral",attrs:{"uuid":_vm.uuid,"type":_vm.type}},[_c('div',{attrs:{"slot":"sample_features"},slot:"sample_features"},[_c('p',[_vm._v("SAMPLE DETAILS (WAITING DATA)")])])])}
var staticRenderFns = []

export { render, staticRenderFns }